import { useState } from 'react'
import ReactDOM from "react-dom";
import { useSelector } from 'react-redux';

import Button from '../../../../common/Button'
import Backdrop from '../../../../common/modal/Backdrop';
import Modal from '../../../../common/Modal';
import ModalInnerWrapper from '../../../../common/ModalInnerWrapper';
import OutsideLienForm from './OutsideLienForm';
import { formatCurrency, totalItemsValue } from '../../../../../lib/script';

import classes from './OutsideLiens.module.css'
import DisplayBoxRight from '../../../../fragments/DisplayBoxRight';
import { useUserTabEditPermissionDisabled } from '../../../../../lib/usersPermissions';

export default function OutsideLiens() {
    const activeCase = useSelector(state => state.case.activeCase) 
    const [modalOpned, setModalOpned] = useState(false)
    const negotiationEditDisabled = useUserTabEditPermissionDisabled('case_negotiation')
    const canEditNegotiation = !negotiationEditDisabled

    function openModalHandler() {
        setModalOpned(true)
    }

    function closeModalHandler() {
        setModalOpned(false)
    }

    return <div style={{flex: 1}}>
        <div className={classes.header}>
            <h3>Outside Liens</h3>
            {canEditNegotiation && (
                <Button click={openModalHandler} btnStyle={'btn_small'}><i className="ti ti-square-plus"></i>add new</Button>
            )}
        </div>
        <table className='table-border-radius-8'>
            <thead>
                <tr>
                    <th>Type</th>
                    <th>Vendor</th>
                    <th>Amount</th>
                </tr>
            </thead>
            <tbody>
                {activeCase && activeCase.case_outside_liens && activeCase.case_outside_liens.map(item => (
                    <tr key={item.id}>
                        <td>{item.type}</td>
                        <td>{item.vendor}</td>
                        <td><DisplayBoxRight>${formatCurrency(item.amount)}</DisplayBoxRight></td>
                    </tr>
                ))}
                
            </tbody>
        </table>

        {activeCase && activeCase.case_outside_liens && <div className={classes.total}>
            <span className={classes.label}>Total Outside Liens:</span>
            <span className={classes.value}>${formatCurrency(totalItemsValue(activeCase.case_outside_liens, 'amount'))}</span>
        </div>}

        {modalOpned && <>
            {ReactDOM.createPortal(
                <Backdrop hide={closeModalHandler} />,
                document.getElementById("backdrop-root")
            )}  
            {ReactDOM.createPortal(
                <Modal>
                    <ModalInnerWrapper closeModal={closeModalHandler} modalTitle={'New Outside Lien'}>
                        <OutsideLienForm closeModal={closeModalHandler}/>
                    </ModalInnerWrapper>
                </Modal>,
                document.getElementById("overlay-root")
            )}          
        </>}
    </div>
}